import { Link } from '@tanstack/react-router';
import createExtractCssFromProps from 'style-utils/createExtractCssFromProps';
import { withOneLineEllipsis } from 'style-utils/overflow';
import styled, { css } from 'styled-components';

type FlexWrapperProps = {
  $isOverlayActive?: boolean;
};

export const FlexWrapper = styled.nav<FlexWrapperProps>`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  width: 100%;
  margin: 0;
  overflow: hidden;
  height: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ $isOverlayActive }) => ($isOverlayActive ? 1001 : 50)};
  background: var(--site-header-bg);
  color: var(--site-header-text);
`;

export const WithBannerFlexWrapper = styled(FlexWrapper)`
  position: absolute;
`;

export const HamburgerButton = styled.button`
  display: inline-block;
  flex: 0 0 auto;
  margin: 0 8px 0 0;
  padding: 0;
  outline: none;
  border: none;
  background: transparent;
  overflow: hidden;
  cursor: pointer;
  color: inherit;
`;
HamburgerButton.defaultProps = {
  type: 'button',
};

export const Notifications = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  flex: 1 1 auto;
  overflow: hidden;
  letter-spacing: 0.2px;
`;

export const NotificationLabel = styled.span`
  display: inline-block;
  width: 100%;
  font-size: 10px;
  letter-spacing: inherit;
  ${withOneLineEllipsis};
  ${createExtractCssFromProps({ textAlign: 'text-align' })};
`;
NotificationLabel.defaultProps = {
  textAlign: 'left',
};

export const CurrencyLabel = styled.span`
  display: inline-block;
  width: 100%;
  letter-spacing: inherit;
  font-size: 12px;
  flex: 0 0 auto;
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  ${withOneLineEllipsis};
`;

const notificationSectionStyles = css`
  display: flex;
  overflow: hidden;
  max-width: 120px;
  height: 100%;
  flex-flow: column nowrap;
  justify-content: center;
  color: inherit;
  flex: 0 1 auto;
  text-decoration: none;
  margin: 0;
  & > * {
    flex: 0 0 auto;
  }
`;

export const BonusLink = styled(Link)`
  ${notificationSectionStyles};
`;

export const BalanceDisplay = styled.div`
  ${notificationSectionStyles};
  padding: 0 12px 0 0;
`;

export const VericalRuler = styled.hr`
  width: 1px;
  height: 19.5px;
  background: currentColor;
  border: none;
  padding: 0;
  flex: 0 0 auto;
  margin: 0 11.5px;
`;

export const NavabarInnerContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 8px;
  height: 40px;
`;

export const SelfExclusionMobileTopBanner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  background: var(--System-yellow50, #fff8e6);
  color: #000;
  padding: 0 16px;
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  border-bottom: 2px solid #ffbf00;
`;
